<template>
  <div>
    <div class="row">
      <div class="col-12 w-100">
        <p class="pb-2 mb-3 color-green-2">
          Importante: Sempre inclua as tags [nome do médico] e [nome do
          treinamento] para o preenchimento automático das informações, conforme
          no texto sugerido para o certificado.
        </p>
      </div>
    </div>
    <b-card border-variant="light" class="custom-card">
      <b-form id="alter-form" class="alter-form">
        <b-form-row>
          <b-col> NOME DO CERTIFICADO </b-col>
          <b-col>
            <b-form-input
              ref="name"
              v-model.lazy.trim="form.name"
              :state="validateField('name')"
              class="mr-5"
              placeholder="Informe o nome do certificado"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> DATA CRIAÇÃO </b-col>
          <b-col class="d-flex justify-content-end mr-5">
            {{ formattedDateStarted }}
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> PERMITIR VÍNCULOS </b-col>
          <b-col class="text-right mr-5">
            <ActivationToogle
              :key="activationToogleKey"
              :certificate="form"
              :showConfirmationModal="isEditing"
              @onUpdateLinkCertificateClick="onUpdateLinkCertificateClick"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> TÍTULO </b-col>
          <b-col>
            <div class="custom-div-reload">
              <b-form-input
                ref="title"
                v-model.lazy.trim="form.title"
                :state="validateField('title')"
                placeholder="Informe o título"
              />
              <img
                class="custom-reload mt-1"
                src="@/assets/icons/restore.svg"
                @click="onSetTitleDefault(false)"
              />
            </div>
          </b-col>
        </b-form-row>
        <b-form-row class="custom-certificate-text">
          <!-- Linha 1: título à esquerda -->
          <b-col cols="12" class="text-size-mobile mb-2" ref="certificateText">
            TEXTO DO CERTIFICADO
          </b-col>

          <!-- Linha 2: textarea 100% largura -->
          <b-col cols="12" class="h-100">
            <div class="custom-div-reload h-90">
              <b-form-textarea
                id="textarea"
                v-model="form.certificateText"
                :state="validateField('certificateText')"
                placeholder="Informe o texto do certificado"
                class="custom-height-area h-100"
                size="lg"
              ></b-form-textarea>
              <img
                class="custom-reload mt-1"
                src="@/assets/icons/restore.svg"
                @click="onSetCertificateTextDefault(false)"
              />
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="">
            <upload-file
              @updateFile="eventToUpdateFile"
              :multiple="false"
              :description="'Adicionar imagem do certificado'"
              :msgErro="'É necessário inserir uma imagem.'"
              :state="validateFieldFile('files')"
              :required="true"
              ref="upload"
              v-model.lazy.trim="form.files"
            >
              <template slot="custon-label">
                <div
                  id="tooltip-custom-label"
                  class="d-inline-block pl-1"
                  tabindex="1"
                >
                  A imagem deve ter dimensão de 20cm x 28cm, no formato PNG.
                </div>
              </template>
            </upload-file>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>
    <b-row
      class="my-5 d-flex content-between justify-content-between custom-buttons"
    >
      <div>
        <b-button
          variant="outline-primary"
          :disabled="this.loading"
          @click="this.onCancel"
          class="ml-4"
        >
          Cancelar
        </b-button>

        <b-button
          form="alter-form"
          type="button"
          class="ml-4"
          variant="primary"
          id="submitButtonText"
          :disabled="this.loading"
          @click="() => this.onSubmitHandler(false)"
        >
          Salvar
        </b-button>
      </div>
      <b-button
        variant="outline-primary"
        :disabled="this.loading || (form.files && form.files.length == 0)"
        v-b-modal:panel-certificate-preview-modal
        class="ml-4"
      >
        Visualizar
      </b-button>
    </b-row>
    <attention-modal
      modalId="confirm-cancel-certificate-modal"
      title="Atenção!"
      submitButtonText="Sim, salvar primeiro"
      cancelButtonText="Prosseguir sem salvar"
      ref="confirm-cancel-certificate-modal"
      :onAction="this.onActionConfirmCancel"
    >
      <template slot="description">
        <p
          class="p1 mb-3 confirm-text d-flex align-items-center justify-content-center"
        >
          Todas as alterações realizadas serão perdidas com esta ação.
        </p>
        <p
          class="p1 mb-5 confirm-text d-flex align-items-center justify-content-center w-100"
        >
          Deseja salvar as alterações antes de prosseguir?
        </p>
      </template>
    </attention-modal>
    <CertificationPreviewModal
      :files="form.files"
      :certificateText="this.form.certificateText"
      :title="this.form.title"
    />
  </div>
</template>

<script>
import {
  validateCheckBox,
  validateField,
  requiredFieldsFilled,
  validateFieldFile,
} from "../../../utils/validate/validate.js";
import { inject } from "@vue/composition-api";
import UploadFile from "../../../components/upload-file/UploadFile.vue";
import {
  saveCertificate,
  updateCertificate,
  getCertificate,
} from "../../../services/certificate/certificateManagementService";
import RoutesPaths from "../../../router/router-structure/routes-paths";
import AttentionModal from "../../../components/base-modals/AttentionModal.vue";
import { createToast } from "../../../components/toast/toast";
import CertificationPreviewModal from "../modal/CertificationPreviewModal.vue";
import { returnDateFormat } from "../../../utils/date/date-utils";
import ActivationToogle from "../components/ActivationToogle.vue";

const DEFAULT_TEXT = "Certificamos que o Dr(a). [nome do médico] participou do treinamento [nome do treinamento], promovido pela Unimed Grande Florianópolis na modalidade on-line."

const DEFAULT_FORM = {
  name: "",
  dateStarted: new Date(new Date().getTime() - 3 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0],
  title: "CERTIFICADO",
  allowLink: false,
  certificateText: DEFAULT_TEXT,
  files: [],
};


export default {
  name: "general-information-certification",
  components: {
    UploadFile,
    AttentionModal,
    CertificationPreviewModal,
    ActivationToogle,
  },
  props: ["onChangeTab", "index"],
  setup() {
    const globalLoading = inject("globalLoading");
    return { globalLoading };
  },
  data() {
    return {
      formSubmited: false,
      dateStartedKey: null,
      activationToogleKey: 0,
      isEditing: false,
      loading: false,
      originalValues: DEFAULT_FORM,
      form: { ...DEFAULT_FORM },
      validations: {},
      validateField,
      validateCheckBox,
      requiredFieldsFilled,
      validateFieldFile,
    };
  },
  computed: {
    formattedDateStarted: {
      get() {
        return returnDateFormat(this.form.dateStarted);
      },
      set(value) {
        this.form.dateStarted = new Date(value); // ou parse personalizado
      },
    },
  },
  async mounted() {
    this.globalLoading = false;
    if (this.$route.params.id) {
      this.loadEditingData();
    }    

    this.activationToogleKey++;
    this.onSetTitleDefault(true);
    this.onSetCertificateTextDefault(true);
  },
  methods: {
    async loadEditingData() {
      this.isEditing = true;
      const certificate = await getCertificate(this.$route.params.id);

      const response = await fetch(this.getLink(certificate));
      const blob = await response.blob();
      const file = new File([blob], "certificado.png", { type: "image/png" });

      this.form = {
        ...this.form,
        id: this.$route.params.id,
        name: certificate.name,
        dateStarted: certificate.dateInicial,
        allowLink: this.isNullOrUndefined(certificate.dateFinal),
        title: certificate.title,
        certificateText: certificate.textFile,
        files: [file],
      };

      this.originalValues = { ...this.form };
      this.$refs.upload.files = [file];
    },
    returnDateFormat: returnDateFormat,
    isNullOrUndefined(value) {
      return value === null || value === undefined;
    },
    getLink({ link }) {
      if (this.$store.getters.isApp) {
        return link.replace("https", "http");
      } else {
        return link;
      }
    },
    onSetTitleDefault(validate) {
      const textDefault = "CERTIFICADO";

      if (!validate) {
        this.form.title = textDefault;
        return;
      }

      if (this.form.title == "") {
        this.form.title = textDefault;
      }
    },
    onSetCertificateTextDefault(validate) {
      const textDefault =
        "Certificamos que o Dr(a). [nome do médico] participou do treinamento [nome do treinamento], promovido pela Unimed Grande Florianópolis na modalidade on-line.";

      if (!validate) {
        this.form.certificateText = textDefault;
        return;
      }

      if (this.form.certificateText == "") {
        this.form.certificateText = textDefault;
      }
    },
    onActionConfirmCancel(confirmed) {
      if (!confirmed) {
        this.$router.push(RoutesPaths.certificationManagement.rootName());
        return;
      }
      this.onSubmitHandler(true);
    },
    getKeyDate(date) {
      return date?.toString();
    },
    onChangedDateStarted(value) {
      this.form.dateStarted = value;
    },
    eventToUpdateFile(files) {
      this.form.files = files;
    },
    onCancel() {      
      if (JSON.stringify(this.originalValues) !== JSON.stringify(this.form)) {
        const modal =
          this.$refs["confirm-cancel-certificate-modal"].$children[0];
        modal.show();
      }
      else {
        this.$router.push(RoutesPaths.certificationManagement.rootName());
      }
    },
    async onSubmitHandler(cancelButton) {
      this.formSubmited = true;
      if (this.requiredFieldsFilled()) {
        this.loading = true;
        try {
          if (this.form.allowLink) {
            this.form = { ...this.form, dateFinished: null };
          } else if (this.isNullOrUndefined(this.form.dateFinal)) {
            this.form = { ...this.form, dateFinished: new Date() };
          }

          if (this.$route.params.id) {
            await updateCertificate({ ...this.form });
          } else {
            await saveCertificate({ ...this.form });
          }

          this.originalValues = { ...this.form };

          createToast(
            "Informação",
            `Certificado ${
              this.form.id ? "editado" : "cadastrado"
            } com sucesso.`,
            "success",
            2000
          );
          setTimeout(async () => {
            this.loading = false;
            if (cancelButton) {
              return;
            } else {
              if (!this.form.id) {
                
                await this.$router.push(
                  RoutesPaths.certificationManagement.rootName()
                );
              }
              this.$props.onChangeTab(this.$props.index + 1);
            }
          }, 1500);
        } catch (error) {
          if (error.response && error.response.status == 400) {
            const msg = `Não é possível ${
              this.form.id ? "alterar" : "salvar"
            } o certificado. Motivo: ${error.response.data.message}`;
            createToast("Informação", msg, "warning");
          } else {
            console.error("onSubmit", error);
            createToast(
              "Atenção",
              "Ocorreu um erro ao salvar informações do treinamento."
            );
          }
          this.loading = false;
        }
      }
    },
    async onUpdateLinkCertificateClick(certificate) {
      this.form.allowLink = !certificate.allowLink;
    },
  },
};
</script>
<style lang="scss">
.b-form-tags-button {
  display: none;
}

.custom-switch label::before,
.custom-switch label::after {
  cursor: pointer !important;
}
</style>
<style lang="scss" scoped>
.b-form-tags-input {
  font-size: 1.2rem;
}
.b-form-tag-content {
  font-size: 1.1rem;
}
.b-form-tag > button.b-form-tag-remove {
  font-size: 180%;
}
.col-tooltip {
  max-width: 0.2rem;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.custom-div-reload {
  display: grid;
  grid-template-columns: auto 24px;
  width: 100%;
  height: 90%;
}
.custom-height-area {
  height: 5rem;
}
.custom-reload {
  cursor: pointer;
}
.custom-certificate-text {
  height: 16rem;
}
.custom-buttons {
  padding-right: 1.5rem;
}
textarea.form-control {
  border: transparent;
  @include header3;
  font-size: multiplier-default-font-size(3) !important;
}
#tooltip-custom-label {
  width: 100%;
  color: var(--grey-3);
  font-size: 12px;
  text-transform: none;
}
</style>
